// extracted by mini-css-extract-plugin
module.exports = {"stockingsInfoModal":"StockingsInfoModal_stockingsInfoModal__2vTwQ","table":"StockingsInfoModal_table__1stWw"};